class InfiniteScrollManager {
  constructor() {
    this.minLoadedPage = 1;
    this.maxLoadedPage = 1;
    this.pagesLoaded = 1;
    this.isLoading = false;
    this.totalPages = 1;
    this.currentUrl = window.location.href;
    
    this.init();
  }
  
  init() {
    const urlParams = new URLSearchParams(window.location.search);
    const currentPage = parseInt(urlParams.get('page')) || 1;
    
    this.minLoadedPage = currentPage;
    this.maxLoadedPage = currentPage;
    this.pagesLoaded = 1;
    
    const paginationNav = document.querySelector('.pagination');
    if (paginationNav) {
      const lastPageLink = paginationNav.querySelector('a[href*="page="]:last-of-type');
      if (lastPageLink) {
        const match = lastPageLink.href.match(/page=(\d+)/);
        if (match) {
          this.totalPages = parseInt(match[1]);
        }
      }
    } else {
      this.totalPages = 999;
    }
    
    this.setupInfiniteScroll();
    this.setupPrevButton();
    this.updateProgress();
  }
  
  setupInfiniteScroll() {
    const infiniteScrollElements = document.querySelectorAll('infinite-scroll[data-trigger="infinite"], .infinite-scroll-element');
    
    infiniteScrollElements.forEach(element => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.isLoading) {
            this.loadNextPage(element);
          }
        });
      }, {
        root: null,
        rootMargin: '0px 0px 350px 0px',
        threshold: 0
      });
      
      observer.observe(element);
    });
  }
  
  setupPrevButton() {
    const prevButton = document.querySelector('.js-show-prev-products');
    if (prevButton) {
      prevButton.addEventListener('click', () => {
        this.loadPrevPage();
      });
    }
  }
  
  async loadNextPage(element) {
    if (this.isLoading || this.maxLoadedPage >= this.totalPages) return;
    
    this.isLoading = true;
    const nextPage = this.maxLoadedPage + 1;
    
    try {
      let nextUrl = element.getAttribute('data-url');
      if (!nextUrl) {
        nextUrl = this.buildPageUrl(nextPage);
      }
      const response = await fetch(nextUrl);
      const html = await response.text();
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newProducts = doc.querySelector('.product-card-list');
      
      if (newProducts && newProducts.innerHTML.trim()) {
        const currentGrid = document.querySelector('.product-card-list');
        if (currentGrid) {
          currentGrid.insertAdjacentHTML('beforeend', newProducts.innerHTML);
        }
        
        this.maxLoadedPage = nextPage;
        this.pagesLoaded++;
        this.updateUrl(nextPage);
        this.updateProgress();
        
        if (typeof initProductHover === 'function') {
          initProductHover();
        }
      }
      
      const newInfiniteScroll = doc.querySelector('infinite-scroll[data-trigger="infinite"]');
      if (newInfiniteScroll) {
        element.setAttribute('data-url', newInfiniteScroll.getAttribute('data-url'));
      } else {
        element.remove();
      }
      
    } catch (error) {
      console.error('Error loading next page:', error);
    } finally {
      this.isLoading = false;
    }
  }
  
  async loadPrevPage() {
    if (this.isLoading || this.minLoadedPage <= 1) return;
    
    this.isLoading = true;
    const prevPage = this.minLoadedPage - 1;
    
    const prevButton = document.querySelector('.js-show-prev-products');
    const spinner = prevButton?.querySelector('.loading-overlay__spinner');
    const buttonText = prevButton?.querySelector('.js-button-text');
    
    if (spinner) spinner.classList.remove('hidden');
    if (buttonText) buttonText.style.visibility = 'hidden';
    if (prevButton) prevButton.disabled = true;
    
    try {
      const prevUrl = this.buildPageUrl(prevPage);
      const response = await fetch(prevUrl);
      const html = await response.text();
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newProducts = doc.querySelector('.product-card-list');
      
      if (newProducts && newProducts.innerHTML.trim()) {
        const currentGrid = document.querySelector('.product-card-list');
        if (currentGrid) {
          currentGrid.insertAdjacentHTML('afterbegin', newProducts.innerHTML);
        }
        
        this.minLoadedPage = prevPage;
        this.pagesLoaded++;
        
        this.updateUrl(prevPage);
        this.updateProgress();
        
        if (typeof initProductHover === 'function') {
          initProductHover();
        }
        
        if (prevPage === 1) {
          prevButton.closest('div').style.display = 'none';
        }
      }
      
    } catch (error) {
      console.error('Error loading previous page:', error);
    } finally {
      this.isLoading = false;
      if (spinner) spinner.classList.add('hidden');
      if (buttonText) buttonText.style.visibility = 'visible';
      if (prevButton) prevButton.disabled = false;
    }
  }
  
  buildPageUrl(pageNumber) {
    const url = new URL(window.location);
    if (pageNumber === 1) {
      url.searchParams.delete('page');
    } else {
      url.searchParams.set('page', pageNumber);
    }
    return url.toString();
  }
  
  updateUrl(pageNumber) {
    const newUrl = this.buildPageUrl(pageNumber);
    history.replaceState(null, '', newUrl);
  }
  
  updateProgress() {
    const progressElement = document.querySelector('.collection-progress');
    if (progressElement) {
      const productsPerPage = parseInt(progressElement.dataset.productsPerPage) || 24;
      const totalProducts = parseInt(progressElement.dataset.totalProducts) || 0;
      const loadedProducts = Math.min(this.pagesLoaded * productsPerPage, totalProducts);
      const percentage = (loadedProducts / totalProducts) * 100;
      
      const progressBar = progressElement.querySelector('.progress-bar');
      if (progressBar) {
        progressBar.style.width = `${percentage}%`;
      }
      
      const progressText = progressElement.querySelector('.progress-text');
      if (progressText) {
        progressText.textContent = `${loadedProducts} / ${totalProducts} ürün gösteriliyor`;
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const infiniteScrollEl = document.querySelector('infinite-scroll[data-trigger="infinite"]');
  const prevButton = document.querySelector('.js-show-prev-products');
  
  if (infiniteScrollEl || prevButton) {
    new InfiniteScrollManager();
  }
});

document.addEventListener('shopify:section:load', () => {
  if (document.querySelector('infinite-scroll[data-trigger="infinite"]') || 
      document.querySelector('.js-show-prev-products')) {
    new InfiniteScrollManager();
  }
});